const { getOffsetTop } = window.BAO.Utils

class TickerText extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupTickerSpeed () {
    const tickerWidth = window.BAO.MediaBreakpoints.isSm
      ? this.els.message.element.offsetWidth / 100
      : this.els.message.element.offsetWidth / 60
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveContainer()
  }

  moveContainer () {
    if (!this.offsetHeight) return

    const amountToMoveX = 100
    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.els.container.element.style.transform = `translate3d(0%, 0px, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.container.element.style.transform = `translate3d(-100%, 0px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountX = amountToMoveX * scrollYAsAPercentageOfJourney

    this.els.container.element.style.transform = `translate3d(-${transformAmountX}%, 0px, 0px)`
  }
}

if (!customElements.get('ticker-text')) {
  customElements.define('ticker-text', TickerText)
}
